import React from 'react'
import cx from 'classnames';
import IndexPage from 'src/pages/IndexPage';

function MainPage({ pageContext }) {
  const {
    coin,
    cryptoCurrencies,
  } = pageContext;

  return (
    <IndexPage coin={coin} cryptoCurrencies={cryptoCurrencies} />
  )
}

export default MainPage;
